import { normalize } from "normalizr";

const recordCache = {};

const getModelForSchema = (schemaId, builder, schemas = {}) => {
    let Record = recordCache[schemaId];
    if (!Record) {
        // build Record
        const schema = schemas[schemaId];
        if (!schema) {
            // this should never happen
            throw new Error(`Schema ${schemaId} not found`);
        }

        Record = builder.create ? builder.create(schema) : builder(schema);
        recordCache[schemaId] = Record;
    }
    return Record;
};

const getRecordsFromSchema = (schema, records = {}) => {
    if (schema.record) {
        records[schema.key] = schema.record;
    }
    if (schema.schema) {
        if (schema.schema._key) {
            getRecordsFromSchema(schema.schema, records);
        } else {
            Object.keys(schema.schema).forEach((key) => {
                getRecordsFromSchema(schema.schema[key], records);
            });
        }
    }
    return records;
};

export const normalizeData = (response, schema, schemas, scope) => {
    const records = getRecordsFromSchema(schema);
    const data = normalize(response.data || response, schema);

    Object.keys(records).forEach((key) => {
        const recordOrBuilder = records[key];
        let Record = recordOrBuilder;
        const collection = data.entities[key];
        if (collection) {
            const keys = Object.keys(collection);
            if (keys.length) {
                // FDM
                if (!recordOrBuilder.prototype.toJS) {
                    if (!scope.brand && !scope.brand._id) {
                        return;
                    }
                    // check if not Immutable Record
                    const schemaId = collection[keys[0]].__schema_id;
                    Record = getModelForSchema(schemaId, recordOrBuilder, schemas);
                }
                keys.forEach((id) => {
                    collection[id] = new Record(collection[id]);
                });
            }
        }
    });

    return data;
};
